module.exports = __webpack_public_path__ + "static/media/2.873e9a80.jpg";